import { CreateEmployeeResponseDTO } from '@/core/dto/psychosocial-report';
import type { CreateEmployeeResponse } from '@/types/Psychosocial';

export class CreateEmployeeMapper {
	constructor(private readonly data: CreateEmployeeResponseDTO) {}

	toDomain(): CreateEmployeeResponse {
		return {
			status: this.data.status,
			message: this.data.message
		};
	}
}
